module.exports = __webpack_public_path__ + "img/test_Icon8.81bf7804.png";